"use client";

import React from "react";
import { Carousel } from "@components/molecules/Carousel";
import { AllFeatureCard } from "@components/molecules/AllFeatureCard";
import styles from "./AllFeaturesCarousel.module.scss";

interface TransformedFeature {
  id: string;
  title: string;
  description: string;
  image: string;
  availableVariants: string;
  available: any;
  category: string;
}

interface AllFeaturesCarouselClientProps {
  allFeatures: TransformedFeature[];
  isSellable: boolean;
  isMMV?: boolean;
  className?: string;
  mmvName?: string;
}


export const AllFeaturesCarouselClient: React.FC<AllFeaturesCarouselClientProps> = React.memo(({
  allFeatures,
  isSellable,
  isMMV,
  className = "",
  mmvName
}) => {
  return (
    <section className={`${styles.allFeaturesCarousel} ${className}`}>
      <div className={styles.bottomSection}>
        <div className={styles.detailedCarousel}>
          <Carousel 
            heading={mmvName?`Key Features of ${mmvName}`:'Key Features'} 
            headingClassName={styles.carouselHeading} 
            arrowButtonClass={styles.arrowButton} 
            isDark 
            className={styles.detailedCarouselContainer} 
            showMobileDots={true}
          >
            {allFeatures.map((feature) => (
              <AllFeatureCard
                key={feature.id}
                feature={feature}
                isDetailed={true}
                isSellable={isSellable}
                isMMV={isMMV}
              />
            ))}
          </Carousel>
        </div>
      </div>
    </section>
  );
});
